import {RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {DefaultLayoutComponent} from './layout/default/default.layout.component';
import {CheckAuthService} from './auth/check-auth.service';
import {AuthCheckComponent} from './auth/auth-check/auth-check.component';
import {LoginComponent} from './auth/login/login.component';
import {SearchCardComponent} from './home/search-card/search-card.component';
import {ResultSearchCardComponent} from './home/result-search-card/result-search-card.component';
import {LogoutComponent} from './auth/logout/logout.component';
import {CardStockDetailComponent} from './home/card-stock-detail/card-stock-detail.component';
import {PriceRuleComponent} from './conf/price-rule/price-rule.component';
import {PriceRuleAddComponent} from './conf/price-rule-add/price-rule-add.component';
import {PriceRuleDetailComponent} from './conf/price-rule-detail/price-rule-detail.component';
import {StockRuleComponent} from './conf/stock-rule/stock-rule.component';
import {StockRuleAddComponent} from './conf/stock-rule-add/stock-rule-add.component';
import {StockRuleDetailComponent} from './conf/stock-rule-detail/stock-rule-detail.component';
import {PriceRuleAddTableComponent} from './conf/price-rule-add-table/price-rule-add-table.component';
import {PriceRuleSetAddComponent} from './conf/price-rule-set-add/price-rule-set-add.component';
import {StockInventoryComponent} from './conf/stock-inventory/stock-inventory.component';


const appRoutes: Routes = [

  {
    path: 'authCheck', component: AuthCheckComponent
  },

  {
    path: 'home', component: DefaultLayoutComponent, canActivate: [CheckAuthService],
    children: [
      {path: '', redirectTo: 'price_rules', pathMatch: 'full'},
      {path: 'search_card', component: SearchCardComponent},
      {path: 'resultSearchCards', component: ResultSearchCardComponent},
      {path: 'card-stock/detail/:cardId', component: CardStockDetailComponent},
      {path: 'stock_inventory', component: StockInventoryComponent},
      {path: 'price_rules', component: PriceRuleComponent},
      {path: 'price_rule_add', component: PriceRuleAddComponent},
      {path: 'price_rule_set_add', component: PriceRuleSetAddComponent},
      {path: 'price_rule_add_table/:expansionId/:rarityId/:categoryId/:brandId', component: PriceRuleAddTableComponent},
      {path: 'price_rule/:brandId/:categoryId/:rule_id', component: PriceRuleDetailComponent},
      // {path: 'price_rule/:rule_id', component: PriceRuleDetailComponent},
      {path: 'stock_rules', component: StockRuleComponent},
      {path: 'stock_rule_add', component: StockRuleAddComponent},
      {path: 'stock_rule/:rule_id', component: StockRuleDetailComponent},
    ]
  },

  {
    path: 'auth',
    children: [
      {path: '', redirectTo: 'login', pathMatch: 'full'},
      {path: 'login', component: LoginComponent},
      {path: 'logout', component: LogoutComponent},
    ]
  },


  {path: '**', redirectTo: '/authCheck'},

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts